<template>
    <info-card-base>
        <template #title>
            {{ period.title }}
        </template>

        <template #price>
            <div class="title" v-if="registrationLink.specialPrice || registrationLink.specialRequirement">
                <s>Rp {{ periodPrice }}</s>
            </div>

            <template v-if="period.is_trial || registrationLink.specialRequirement || period.price == 0">
                Gratis
            </template>

            <template v-else-if="registrationLink.specialPrice">
                Rp {{ specialPrice }}
            </template>

            <template v-else-if="period.price">
                Rp {{ periodPrice }}
            </template>
        </template>

        <template #description v-if="period.description">
            <p
                v-for="(description, i) in descriptions"
                :key="i"
            >
                {{ description }}
            </p>

            <p v-if="registrationLink.specialRequirement">
                {{ registrationLink.specialRequirement }}
            </p>
        </template>
    </info-card-base>
</template>

<script>
import InfoCardBase from './InfoCardBase.vue'
import priceFormat from '@/tools/priceFormat'

export default {
    props: {
        registrationLink: {
            type: Object,
            required: true
        }
    },

    components: {
        InfoCardBase,
    },

    computed: {
        period() {
            return this.registrationLink.period
        },

        specialPrice() {
            return priceFormat(this.registrationLink.specialPrice)
        },

        periodPrice() {
            return priceFormat(this.period.price)
        },

        descriptions() {
            return this.period.description.split('\n')
        }
    }
}
</script>
